<template>
  <div v-if='!isFinished' class="issues-count-cell">
  </div>
  <div v-else-if='isForPasswordSpray' class="issues-count-cell">
    <div class="issues-count-cell__severity issues-count-cell__critical">
      {{ value.authenticatedCredentials }}
    </div>
  </div>
  <div v-else-if='isForEmployees' class="issues-count-cell">
    <div class="issues-count-cell__severity issues-count-cell__leaked">
        <v-icon
          color='#FFA600'>
          water_drop
        </v-icon>
      {{ value.leakedCredentials }}
    </div>
    <div class="issues-count-cell__severity issues-count-cell__cleartext">
      <v-icon
        color='#DF399F'>
        key
      </v-icon>
      {{ value.clearTextCredentials }}
    </div>
  </div>
  <div v-else-if='isForCompliance' class="issues-count-cell compliance-count-cell">
    <div class="issues-count-cell__severity issues-count-cell__compliance-info">
      {{ value.info }}
    </div>
    <div class="issues-count-cell__severity issues-count-cell__compliance-pass">
      {{ value.pass }}
    </div>
    <div class="issues-count-cell__severity issues-count-cell__compliance-fail">
      {{ value.fail }}
    </div>
  </div>
  <div v-else class="issues-count-cell">
    <div class="issues-count-cell__severity issues-count-cell__info">
      {{ value.informative }}
    </div>
    <div class="issues-count-cell__severity issues-count-cell__low">
      {{ value.low }}
    </div>
    <div class="issues-count-cell__severity issues-count-cell__medium">
      {{ value.medium }}
    </div>
    <div class="issues-count-cell__severity issues-count-cell__high">
      {{ value.high }}
    </div>
    <div class="issues-count-cell__severity issues-count-cell__critical">
      {{ value.critical }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProjectIssuesCountTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    value() {
      return this.item.issuesCount;
    },
    isForPasswordSpray() {
      return (this.item.activity.trim().toLowerCase() === 'password spray');
    },
    isForEmployees() {
      return (this.item.activity.trim().toLowerCase() === 'employees');
    },
    isForCompliance() {
      return (this.item.activity.trim().toLowerCase() === this.$t('project.type.cloud-compliance').trim().toLowerCase());
    },
    isFinished() {
      return (this.item.status.trim().toLowerCase() === 'finished');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.issues-count-cell {
  align-items: center;
  z-index: 3;
  justify-content: center;
  font-family: $font-family-bold;
  font-size: $font-size-base;
  font-weight: bold;
  letter-spacing: 0;
  line-height: rem(17);
  display: var(--displayissuecountcell);
  position: fixed;
  right: $space-1;
  background: var(--bg-primary, #ffffff);

  &::before {
    content: '';
    position: absolute;
    left: rem(-60);
    top: 0;
    width: rem(60);
    height: 100%;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, var(--bg-primary, #ffffff) 100%);
    pointer-events: none;
  }

  &__severity {
    padding: rem(3) $space-1;
    min-width: rem(37);
    min-height: rem(25);
    border-radius: $radius-md;
    text-align: center;
    margin-right: $space-1;
    margin-top: rem(3);

    .v-icon {
      font-size: $font-size-md;
      max-width: rem(16);
    }
  }

  &__info,
  &__compliance-info {
    background-color: var(--severity-info-bg);
    color: var(--severity-info);
  }

  &__low,
  &__compliance-pass {
    background-color: var(--severity-low-bg);
    color: var(--severity-low);
  }

  &__medium {
    background-color: var(--severity-medium-bg);
    color: var(--severity-medium);
  }

  &__high {
    background-color: var(--severity-high-bg);
    color: var(--severity-high);
  }

  &__critical,
  &__compliance-fail {
    background-color: var(--severity-critical-bg);
    color: var(--severity-critical);
  }

  &__leaked {
    background-color: rgba(255, 167, 0, 0.15);
    color: #FFA600;
  }

  &__cleartext {
    background-color: rgba(223, 57, 159, 0.12);
    color: #DF399F;
  }

  &__compliance-info,
  &__compliance-pass,
  &__compliance-fail {
    width: rem(55);
  }
}

.compliance-count-cell {
  margin-right: $space-2;
}
</style>
